import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresColaborador', {
    template: template,
    controller: NominasNominaColaboradoresColaboradorComponent,
    bindings: {
      data: '<',
      conceptos: '<',
      editable: '<',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresColaboradorComponent($filter) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.recalcular = recalcular
  $ctrl.recalcularUsd = recalcularUsd

  function $onInit() {
    $ctrl.autofocus = !$ctrl.data.importe

    $ctrl.percepciones = $filter('orderBy')($ctrl.conceptos.filter(function (item) {
      return item.naturaleza === 'P'
        && ($ctrl.editable ? true : $ctrl.data.percepciones[item.id])
    }), 'concepto')

    $ctrl.deducciones = $filter('orderBy')($ctrl.conceptos.filter(function (item) {
      return item.naturaleza === 'D'
        && ($ctrl.editable ? true : $ctrl.data.deducciones[item.id])
    }), 'concepto')
  }

  function recalcularUsd() {
    $ctrl.data.importe = Math.round($ctrl.data.importe_divisa * $ctrl.data.tipo_cambio * 100) / 100
    recalcular()
  }

  function recalcular() {
    $ctrl.data.comision_importe = $ctrl.data.importe && $ctrl.data.comision_porcentaje
      ? Math.round($ctrl.data.importe * $ctrl.data.comision_porcentaje * 100) / 100
      : 0

    $ctrl.data.neto = $ctrl.data.importe - $ctrl.data.comision_importe

    $ctrl.data.total_percepciones = 0
    angular.forEach($ctrl.data.percepciones, function (value) {
      $ctrl.data.total_percepciones += value.importe
    })

    $ctrl.data.total_deducciones = 0
    angular.forEach($ctrl.data.deducciones, function (value) {
      $ctrl.data.total_deducciones += value.importe
    })

    $ctrl.data.neto_a_pagar = null

    $ctrl.onChange({$event: {data: $ctrl.data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/colaborador/component.js